
import React, { useState } from "react";
import Banner from "../../components/Banner/Banner";
import AdvanceSearch from "../../components/AdvanceSearch/AdvanceSearch";
import Features from "../../components/Features/Features";
import { Container, Row, Col, Card, } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./home.css";
import Gallery from "../../components/Gallery/Gallery";
import { collection, getDocs, } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import ClientForm from "../../components/ClientForm/ClientForm";
import icons1 from "../../assets/images/icons/destination.png";
import icons2 from "../../assets/images/icons/best-price.png";
import icons3 from "../../assets/images/icons/quick.png";
import aboutImg from "../../assets/images/about/aboutimg.webp";
import qr from "../../assets/images/qr.webp";
import { useNavigate } from "react-router-dom";
import AbuTripDetails from "../../components/abuTripDetails/AbuTripDetails";
import { Helmet } from "react-helmet-async";
import ExplorebyState from "../../components/ExplorebyState/ExplorebyState";
import TopDestination from "../../components/TopDestination/TopDestination";
import HomeBlogs from "../Blog/HomeBlogs";

const Home = () => {
  const [tours, setTours] = useState([]);
  const navigate = useNavigate();

  const fetchTours = async () => {
    try {
      const snapshot = await getDocs(collection(fireDB, "tours"));
      const fetchedTours = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTours(fetchedTours);
    } catch (error) {
      console.error("Error fetching tours:", error);
    }
  };

  return (
    <>
      <Helmet>
        <title>Top Travel & Tour Company in India | Shivay Tour and Travells</title>
        <meta
          name="description"
          content="Looking for trusted travel tour companies? Shivay Tour and Travells offers unforgettable custom tours across India. Plan your dream vacation today!"
        />
        <meta name="keywords" content="travel tour companies, Gujarat tours, India travel packages" />

        <link rel="canonical" href="https://www.shivaytourandtravells.com/" />

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "TravelAgency",
                "name": "Shivay Tour and Travells",
                "description": "As one of the top travel tour companies in Gujarat, we offer unforgettable and budget-friendly custom trips across India. Plan your dream vacation with us today!",
                "image": "https://www.shivaytourandtravells.com/logo.png",
                "@id": "https://www.shivaytourandtravells.com/#organization",
                "url": "https://www.shivaytourandtravells.com/",
                "telephone": "+91-9876543210",
                "priceRange": "$$",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "123 Travel Street",
                  "addressLocality": "Surat",
                  "addressRegion": "GJ",
                  "postalCode": "395006",
                  "addressCountry": "IN"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": 21.1702,
                  "longitude": 72.8311
                },
                "openingHoursSpecification": {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday"
                  ],
                  "opens": "09:00",
                  "closes": "20:00"
                },
                "sameAs": [
                  "https://www.facebook.com/shivaytravels",
                  "https://www.instagram.com/shivaytravels",
                  "https://www.twitter.com/shivaytravels"
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "185"
                }
              },
              {
                "@type": "WebSite",
                "@id": "https://www.shivaytourandtravells.com/#website",
                "url": "https://www.shivaytourandtravells.com/",
                "name": "Shivay Tour and Travells",
                "description": "Trusted travel tour companies offering custom tour packages across India.",
                "publisher": {
                  "@id": "https://www.shivaytourandtravells.com/#organization"
                },
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": {
                    "@type": "EntryPoint",
                    "urlTemplate": "https://www.shivaytourandtravells.com/search?q={search_term_string}"
                  },
                  "query-input": "required name=search_term_string"
                }
              },
              {
                "@type": "FAQPage",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "What makes Shivay Tour and Travells one of the best travel tour companies?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "With over 10 years of expertise, personalized itineraries, 24/7 support, and verified local guides, we focus on creating a seamless and unforgettable journey for every traveler."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Do you offer custom tour packages?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, absolutely! We specialize in creating custom and flexible travel plans tailored to your specific interests, budget, and travel style. Contact us to build your dream trip."
                    }
                  }
                ]
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <Banner />
      <AdvanceSearch />
      <Features />
      <HomeBlogs />
      <AbuTripDetails />
      <ExplorebyState />
      <TopDestination />

      <section className="py-5">
        <Container>
          <Row>
            <Col md={8}>
              <div className="about-content">
                {/* About image with heading overlay */}
                <div className="about-image position-relative">
                  <img
                    src={aboutImg}
                    alt="about"
                    loading="lazy"
                    className="img-fluid rounded-5"
                  />
                  <div className="about-image-content position-absolute top-50 end-0 p-md-4 p-3 rounded-5 shadow-sm">
                    <h3 className="h2 fw-bold text-white">
                      HOW WE ARE BEST FOR TRAVEL!
                    </h3>
                  </div>
                </div>

                {/* Main Heading */}
                <h2 className="h2 font-bold pt-4 pb-2 custom-heading text-primary-emphasis">
                  Your Journey, Our Passion: Discover India With a Company That Cares
                </h2>

                {/* Main Content */}
                <p className="body-text mb-3">
                  In a world full of travel tour companies, finding one that truly understands your dream of adventure can make all the difference.
                  At <strong>Shivay Tour & Travels</strong>, we don't just plan trips; we craft unforgettable stories.
                  Your journey through the heart of Gujarat and India is our deepest passion,
                  and we promise to make it seamless, secure, and filled with moments you'll cherish forever.
                </p>

                <p className="body-text mb-3">
                  Imagine standing in quiet reverence at the ancient temples of Somnath,
                  feeling the vast, starlit expanse of the Rann of Kutch,
                  or letting the warm waves of Diu's vibrant beaches wash over your feet.
                  These aren't just destinations; they are experiences waiting to awaken your soul.
                </p>

                <p className="body-text mb-3">
                  Join a family of thousands of happy travelers who have trusted us with their precious memories.
                  Now, it's your turn to create yours.
                </p>

                <h4 className="pt-4 fw-semibold custom-heading">Our Mission: To Tell Your Perfect Travel Story</h4>
                <p className="body-text mb-3">
                  We believe travel should be personal, effortless, and transformative.
                  Our entire mission is dedicated to providing you with a personalized, hassle-free experience
                  from the first phone call to your safe return home — with a smile on your face and a story in your heart.
                </p>

                <h4 className="pt-4 fw-semibold custom-heading">What Makes Our Journeys Different?</h4>
                <ul className="body-text ps-3">
                  <li><strong>✅ A Decade of Passion:</strong> With over 10 years of expertise, we're not just agents; we're local storytellers who know every hidden gem of Gujarat and India.</li>
                  <li><strong>✅ Your Dream, Your Itinerary:</strong> Forget rigid, one-size-fits-all plans. We listen to you and craft flexible, custom journeys that revolve entirely around your wishes.</li>
                  <li><strong>✅ Peace of Mind, 24/7:</strong> Adventure can be unpredictable. That’s why our support is always just a call or WhatsApp message away, ensuring you feel secure every step of the way.</li>
                  <li><strong>✅ Trusted Comfort & Safety:</strong> We personally select and verify every hotel and local guide, because your comfort and safety are the foundation of a wonderful trip.</li>
                </ul>

                <h4 className="pt-4 fw-semibold custom-heading">Meet the Heart of Shivay Travels</h4>
                <p className="body-text mb-3">
                  Our team isn't just made up of travel planners; we are passionate locals who were born and raised here.
                  We've explored the hidden alleys, tasted the best local food, and know the secrets that transform a good trip into a life-changing experience.
                  Allow us to share our home, our culture, and our passion with you.
                </p>

                {/* Highlighted customer block */}
                <div
                  className="p-4 my-4 rounded-4 shadow-sm"
                  style={{ background: "linear-gradient(135deg, #e0f7fa, #fff)" }}
                >
                  <h5 className="fw-bold text-success d-flex align-items-center gap-2">
                    <i className="bi bi-people-fill"></i> Over{" "}
                    <span className="text-primary">1,000+</span> Happy Customers
                  </h5>
                  <p className="body-text m-0">
                    Join thousands who explored Gujarat with Shivay Travels and created unforgettable memories.
                  </p>
                </div>

                {/* Optional quote */}
                <div className="bg-white rounded-4 p-3 shadow-sm border-start border-4 border-success my-4">
                  <blockquote className="blockquote mb-0">
                    <p>"Travel is the only thing you buy that makes you richer."</p>
                  </blockquote>
                </div>
              </div>
            </Col>

            {/* Features side cards */}

            <Col md={4}>
              <div
                className="p-4 rounded-4 shadow-sm mb-4"
                style={{
                  background: "linear-gradient(135deg, #f0f4f8, #ffffff)",
                }}
              >
                <h5 className="fw-bold custom-heading mb-3">🚍 Our Travel Services</h5>
                <ul className="ps-3 body-text mb-3">
                  <li className="mb-2">✈️ <strong>Flight Ticket Booking</strong></li>
                  <li className="mb-2">🚆 <strong>Train Ticket Booking</strong></li>
                  <li className="mb-2">🚌 <strong>Bus Ticket Booking</strong></li>
                  <li className="mb-2">🌍 <strong>International Tours</strong></li>
                  <li className="mb-2">🏞️ <strong>Domestic Tours</strong></li>
                  <li className="mb-2">🏢 <strong>Corporate Tours</strong></li>
                  <li className="mb-2">🏨 <strong>Hotel Booking</strong></li>
                </ul>

                <div className="bg-white rounded-4 shadow-sm p-3 mb-3 border-start border-4 border-primary">
                  <p className="mb-1">
                    <strong>🎁 Tour Packages:</strong> Solo / Couple / Family / Group
                  </p>
                  <p className="mb-0"><strong>🚌 Vehicles:</strong></p>
                  <div className="custom-heading fw-bold">
                    5, 7, 9, 12, 14, 17, 20, 25, 33, 37, 40, 56 Seater
                  </div>
                </div>

                <div className="text-center mt-3">
                  <div className="d-inline-block p-2 bg-white rounded-4 shadow-sm">
                    <img
                      src={qr}
                      alt="Instagram QR"
                      loading="lazy"
                      className="img-fluid rounded-3"
                      style={{ maxWidth: "180px" }}
                    />
                  </div>
                  <p className="body-text mt-2 mb-0">
                    📸 Scan to follow us on Instagram
                  </p>
                  <div className="mt-3">
                    <button
                      className="btn btn-primary btn-lg rounded-pill px-4 shadow"
                      onClick={() => window.location.href = "/contact-us"}
                    >
                      📅 Book Now
                    </button>
                  </div>
                </div>
              </div>

              {[icons1, icons2, icons3].map((icon, idx) => (
                <Card className="border-0 shadow-sm rounded-3 mb-4" key={idx}>
                  <Card.Body className="text-center">
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <div
                        className="rounded-circle bg-white p-3 shadow-sm d-flex align-items-center justify-content-center"
                        style={{ width: 80, height: 80 }}
                      >
                        <img
                          src={icon}
                          alt={`icon-${idx}`}
                          className="img-fluid"
                          style={{ maxHeight: 40 }}
                        />
                      </div>
                    </div>
                    <Card.Title className="fw-bold h5 custom-heading">
                      {idx === 0
                        ? "50+ Destinations"
                        : idx === 1
                          ? "Best Price Guarantee"
                          : "Super Fast Booking"}
                    </Card.Title>
                    <p className="mb-2 body-text">
                      {idx === 0
                        ? "Explore beautiful places across Gujarat and India."
                        : idx === 1
                          ? "No hidden charges — just the best deals with satisfaction."
                          : "Get quick confirmations via WhatsApp or call."}
                    </p>
                  </Card.Body>
                </Card>
              ))}
            </Col>
          </Row>
        </Container>

      </section>

      {/* Top Destinations Section */}

      <ClientForm />




      {/* Call To Action */}
      <section className="call_us">
        <Container>
          <Row className="align-items-center">
            <Col md="8">
              <h5 className="title">CALL TO ACTION</h5>
              <h2 className="heading">
                READY FOR UNFORGETTABLE TRAVEL? REMEMBER US!
              </h2>
              <p className="text">
                Contact us today and let’s plan your dream journey across
                Gujarat & India. From spiritual destinations to adventure tours
                — we’ve got you covered.
              </p>
            </Col>
            <Col md="4" className="text-center mt-3 mt-md-0">
              <div className="d-flex flex-column align-items-center gap-2">
                <a href="tel:7600668600" className="btn btn-primary w-100">
                  📞 Call: 7600 66 8600
                </a>
                <a href="tel:9173005554" className="btn btn-primary w-100">
                  📞 Call: 917 300 5554
                </a>
                <a
                  href="https://wa.me/9173005554"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success w-100"
                >
                  💬 WhatsApp Us
                </a>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="overlay"></div>
      </section>

      {/* Photo Gallery Section */}
      <section className="gallery">
        <Container>
          <Row>
            <Col md="12">
              <div className="main_heading">
                <h1>Photo Gallery </h1>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Gallery />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 bg-light">
        <Container>
          <h3 className="text-center fw-bold mb-4 custom-heading text-primary-emphasis">
            <i className="bi bi-geo-alt-fill me-2"></i> Our Location – Surat, Gujarat
          </h3>
          <div className="map-responsive rounded-4 overflow-hidden shadow-sm">
            <iframe
              title="Shivay Tour & Travels Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29756.341825760184!2d72.8506602!3d21.2103167!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f0033c9b25d%3A0x3b4b26f6090459cf!2sRiddhi%20Apartment!5e0!3m2!1sen!2sin!4v1752257354242!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Home;
